import { Badge, Box, Button, Checkbox, FormControlLabel, Paper, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useEffect, useState } from "react";

// TEMPORARY FIX: these insurers only work on a quotation started after they were added, so
// the first time one of them is selected the user is told to start a new quotation.
// [REQUIRED FOR NEW INSURER] add the insurer here when it needs the same fix.
const NEW_QUOTATION_REQUIRED_INSURERS = {
  pacific_cross_primary_care_plan: { alertMessage: 'You should start a new Quotation to use the Pacific Cross PrimaryCare Plan', alertShownKey: 'pacificCrossPrimaryCarePlanNewQuotationAlertShown' },
  pacific_cross_select: { alertMessage: 'You should start a new Quotation to use the Pacific Cross Select', alertShownKey: 'pacificCrossSelectNewQuotationAlertShown' },
  pacific_cross_blue_royale: { alertMessage: 'You should start a new Quotation to use the Pacific Cross Blue Royale', alertShownKey: 'pacificCrossBlueRoyaleNewQuotationAlertShown' },
  cigna_global_health_option: { alertMessage: 'You should start a new Quotation to use the Cigna Global Health Option', alertShownKey: 'cignaGlobalHealthOptionNewQuotationAlertShown' },
  cigna_care_connect: { alertMessage: 'You should start a new Quotation to use Cigna Care Connect', alertShownKey: 'cignaCareConnectNewQuotationAlertShown' },
  hsbc_smart_care_optimum_enhanced: { alertMessage: 'You should start a new Quotation to use HSBC SmartCare Optimum Enhanced', alertShownKey: 'hsbcSmartCareOptimumEnhancedNewQuotationAlertShown' },
};

// A single new quotation covers all of these temporary fixes, so once the user has started one, don't ask again for any of them.
const NEW_QUOTATION_ALERT_SHOWN_KEYS = Object.values(NEW_QUOTATION_REQUIRED_INSURERS).map(({ alertShownKey }) => alertShownKey);

export function markAllNewQuotationAlertsShown() {
  NEW_QUOTATION_ALERT_SHOWN_KEYS.forEach((alertKey) => localStorage.setItem(alertKey, 'true'));
}

function isNewQuotationAlertShown(key) {
  return localStorage.getItem(NEW_QUOTATION_REQUIRED_INSURERS[key].alertShownKey) === 'true';
}

export default function SelectInsurers({ insurers, setInsurers, sx, fetchQuotationByKey, showResult, pendingTasks, setPendingTasks,
  displayStatus, setDisplayStatus, updateDisplayStatus, onStartNewQuotation
}) {
  const [selectAll, setSelectAll] = useState(false);

  const { lifeline, bwho, company, oil_gas, first_choice, ihhp, vumi, my_health_indonesia, my_health_singapore, my_health_vietnam, my_health_philippines, optimum_global, morgan_price, pro_medico, cigna_care_connect, allianz_care_singapore, bhp_indonesia, pacific_cross_primary_care_plan, pacific_cross_select, pacific_cross_blue_royale, cigna_global_health_option, hsbc_smart_care_optimum_enhanced } = insurers;


  function handleSelectAllChange(newValue) {
    const allChecked = checkIfAllChecked();
    const updatedInsurers = {};

    for (const [key, value] of Object.entries(insurers)) {
      updatedInsurers[key] = newValue;
    }

    setInsurers(updatedInsurers);
    setSelectAll(newValue);

    setDisplayStatus(updatedInsurers);
  }

  function checkIfAllChecked() {
    for (const [key, value] of Object.entries(insurers)) {
      if (!value) {
        return false;
      }
    }

    return true;
  }

  function checkIfIndeterminate() {
    const allChecked = checkIfAllChecked();

    if (allChecked) {
      return false;
    }

    for (const [key, value] of Object.entries(insurers)) {
      if (value == true) {
        return true;
      }
    }

    return false;
  }

  const handleChange = (event) => {
    const key = event.target.name;
    const checked = event.target.checked;

    // TEMPORARY FIX: force a new quotation before using an insurer that needs one.
    if (checked && NEW_QUOTATION_REQUIRED_INSURERS[key] && !isNewQuotationAlertShown(key)) {
      markAllNewQuotationAlertsShown();
      window.alert(NEW_QUOTATION_REQUIRED_INSURERS[key].alertMessage);
      onStartNewQuotation?.(key);
      return;
    }

    if (checked && showResult) {
      // fetchQuotationByKey(key);
      const _pendingTasks = JSON.parse(JSON.stringify(pendingTasks));


      if (!_pendingTasks.includes(key)) {
        _pendingTasks.push(key);
      }

      setPendingTasks([..._pendingTasks]);
    } else {
      displayStatus[key] = false;
      setDisplayStatus(displayStatus);
    }


    setInsurers({
      ...insurers,
      [key]: checked,
    });
  };

  return (
    <Paper id="select-insurer-card" sx={{ p: 2, ...sx, position: 'sticky', backgroundColor: '#002047', color: '#fff' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography fontWeight={600} fontSize={21} sx={{ mr: 2 }}>Select Insurer / Type of Cover</Typography>
          <Button onClick={() => {
            handleSelectAllChange(false);



          }} sx={{ color: '#fff' }}>Clear Insurers</Button>
        </Box>

        {/* <FormControlLabel
          control={
            <Checkbox checked={selectAll} onChange={(e) => { handleSelectAllChange(e.target.checked) }} indeterminate={checkIfIndeterminate()} />
          }
          label="ALL INSURERS"
        /> */}
      </Box>
      <Box sx={{ display: 'flex', mt: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', mr: 7 }}>
          <FormControlLabel
            labelStyle={{ color: 'white' }}
            iconStyle={{ fill: 'white' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={lifeline} onChange={handleChange} name="lifeline" />
            }
            label="BUPA Lifeline"
          />
          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={bwho} onChange={handleChange} name="bwho" />
            }
            label="BUPA WHO"
          />
          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={company} onChange={handleChange} name="company" />
            }
            label="BUPA Company"
          />
          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={oil_gas} onChange={handleChange} name="oil_gas" />
            }
            label="BUPA Oil & Gas"
          />
          {/* <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={first_choice} onChange={handleChange} name="first_choice" />
            }
            label="BUPA First Choice"
          /> */}

          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={ihhp} onChange={handleChange} name="ihhp" />
            }
            label="BUPA IHHP KSK"
          />

          <FormControlLabel
            labelStyle={{ color: 'white' }}
            iconStyle={{ fill: 'white' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={bhp_indonesia} onChange={handleChange} name="bhp_indonesia" />
            }
            label="BUPA BHP Indonesia"
          />

        </Box>

        
        <Box sx={{ display: 'flex', flexDirection: 'column', mr: 7 }}>
          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={vumi} onChange={handleChange} name="vumi"
              />
            }
            label="VUMI"
          />
          
          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={optimum_global} onChange={handleChange} name="optimum_global" />
            }
            label="AXA - Optimum Global"
          />


          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={morgan_price} onChange={handleChange} name="morgan_price" />
            }
            label="Morgan Price International"
          />

          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={pro_medico} onChange={handleChange} name="pro_medico"
              />
            }
            label="Liberty proMedico"
          />

          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={cigna_care_connect} onChange={handleChange} name="cigna_care_connect"
              />
            }
            label="Cigna Care Connect"
          />

          <FormControlLabel
            sx={{ color: '#4caf50' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={cigna_global_health_option} onChange={handleChange} name="cigna_global_health_option" />
            }
            label="Cigna Global Health Option"
          />

          <FormControlLabel
            sx={{ color: '#4caf50' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={pacific_cross_primary_care_plan} onChange={handleChange} name="pacific_cross_primary_care_plan"
              />
            }
            label="Pacific Cross PrimaryCare Plan"
          />

          <FormControlLabel
            sx={{ color: '#4caf50' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={pacific_cross_select} onChange={handleChange} name="pacific_cross_select"
              />
            }
            label="Pacific Cross Select"
          />

          <FormControlLabel
            sx={{ color: '#4caf50' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={pacific_cross_blue_royale} onChange={handleChange} name="pacific_cross_blue_royale"
              />
            }
            label="Pacific Cross Blue Royale"
          />

          <FormControlLabel
            sx={{ color: '#4caf50' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={hsbc_smart_care_optimum_enhanced} onChange={handleChange} name="hsbc_smart_care_optimum_enhanced" />
            }
            label="HSBC SmartCare Optimum Enhanced"
          />

          {/* <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={allianz_care_singapore} onChange={handleChange} name="allianz_care_singapore"
              />
            }
            label="Allianz Care - Singapore"
          /> */}

        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>

          {/* <Typography sx={{ mb: 1, fontSize: 14, color: '#e0e0e0' }}>These insurers/products are not yet accessible, as below products are still in the development phase.</Typography> */}

          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={my_health_indonesia} onChange={handleChange} name="my_health_indonesia" />
            }
            label="April (MyHealth) Indonesia"
          />
          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={!!my_health_singapore} onChange={handleChange} name="my_health_singapore" />
            }
            label="April (MyHealth) Singapore"
          />
          {/* <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={my_health_vietnam} onChange={handleChange} name="my_health_vietnam" />
            }
            label="April (MyHealth) Vietnam"
          /> */}

          <FormControlLabel
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={my_health_philippines} onChange={handleChange} name="my_health_philippines" />
            }
            label="April (MyHealth) Philippines"
          />
          {/* <FormControlLabel
            sx={{ color: '#9e9e9e' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={false} readOnly
              />
            }
            label="IMG Global Prima"
          /> */}

          {/* <FormControlLabel
            sx={{ color: '#9e9e9e' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={false} readOnly
              />
            }
            label="Luma - Asia Care Plus (International)"
          /> */}
          {/* <FormControlLabel
            sx={{ color: '#9e9e9e' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={false} readOnly
              />
            }
            label="Luma - Asia Care Plus (Vietnam)"
          /> */}
          {/* <FormControlLabel
            sx={{ color: '#9e9e9e' }}
            control={
              <Checkbox sx={{
                color: '#fff', '&.Mui-checked': {
                  color: '#fff',
                },
              }} checked={false} readOnly
              />
            }
            label="William Russell"
          /> */}

        </Box>
      </Box>

    </Paper>
  );
}